var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#393ABD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70757 11.793C6.61532 11.6975 6.50498 11.6213 6.38297 11.5689C6.26097 11.5165 6.12975 11.4889 5.99697 11.4877C5.86419 11.4866 5.73251 11.5119 5.60962 11.5622C5.48672 11.6124 5.37507 11.6867 5.28117 11.7806C5.18728 11.8745 5.11303 11.9861 5.06275 12.109C5.01247 12.2319 4.98717 12.3636 4.98832 12.4964C4.98947 12.6292 5.01706 12.7604 5.06947 12.8824C5.12188 13.0044 5.19806 13.1147 5.29357 13.207L6.70757 11.793ZM10.0006 16.5L9.29357 17.207C9.4811 17.3945 9.7354 17.4998 10.0006 17.4998C10.2657 17.4998 10.52 17.3945 10.7076 17.207L10.0006 16.5ZM18.7076 9.20698C18.8897 9.01838 18.9905 8.76578 18.9882 8.50358C18.986 8.24138 18.8808 7.99057 18.6954 7.80516C18.51 7.61975 18.2592 7.51458 17.997 7.51231C17.7348 7.51003 17.4822 7.61082 17.2936 7.79298L18.7076 9.20698ZM5.29357 13.207L9.29357 17.207L10.7076 15.793L6.70757 11.793L5.29357 13.207ZM10.7076 17.207L18.7076 9.20698L17.2936 7.79298L9.29357 15.793L10.7076 17.207Z",
    fill: "#F4F6F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFill);
export default __webpack_public_path__ + "static/media/check-fill.ffa593eeb089816a23aa423089a06097.svg";
export { ForwardRef as ReactComponent };